
import { defineComponent, onBeforeMount, ref } from 'vue';
import axios, { AxiosError } from 'axios';
import { assignRoleToUser, getAllRoles, invokeGetUserRole, removeRoleFromUser } from '@/utils/admin/master_service';

export default defineComponent({
  name: 'AssignRoleToOhr',
  setup() {
    const ohrToAssignRole = ref('');
    const renderReady = ref(true);
    const selectedRole = ref();
    const errorMessage = ref();
    const userRole = ref();
    const showScreen = ref(true);
    const showSuccessMessage = ref(false);
    const resMessage = ref();
    const showErrorMessage = ref(false);
    const roles = ref();
    // const roles = ['System Admin', 'System Admin View Access', 'Proxy Admin', 'Community Manager', 'Knowledge Manager', 'Guru', 'Master Guru', 'Program Admin', 'Learner'];
    const updateRecord = async () => {
      try {
        if (selectedRole.value === undefined) {
          errorMessage.value = 'Please Select One Role';
          setTimeout(() => {
            errorMessage.value = null;
          }, 6000);
        } else if (!ohrToAssignRole.value) {
          errorMessage.value = 'Please Enter OHR to Assign Role';
          setTimeout(() => {
            errorMessage.value = null;
          }, 6000);
        } else {
          renderReady.value = false;
          console.log(`selectedRole ${selectedRole.value}`);
          const ohrList: string[] = [];
          ohrList.push(ohrToAssignRole.value);
          const data = {
            ohr_list: ohrList,
            role_name: selectedRole.value,
          };
          console.log(`data ${JSON.stringify(data)}`);
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const res: any = await assignRoleToUser(data);
          resMessage.value = res.data;
          renderReady.value = true;
          showSuccessMessage.value = true;
          // console.log(`showSuccessMessage.value ${JSON.stringify(res)}`);
          setTimeout(() => {
            showSuccessMessage.value = false;
          }, 2000);
        }
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          // console.log(err.response?.data);
          renderReady.value = true;
          resMessage.value = (err.response?.data as { message: string })?.message;
          // console.log(`errorMessage.value ${errorMessage.value}`);
          showErrorMessage.value = true;
          setTimeout(() => {
            showErrorMessage.value = false;
          }, 2000);
        }
      }
    };
    const removeRole = async () => {
      try {
        if (selectedRole.value === undefined) {
          errorMessage.value = 'Please Select One Role';
          setTimeout(() => {
            errorMessage.value = null;
          }, 6000);
        } else if (!ohrToAssignRole.value) {
          errorMessage.value = 'Please Enter OHR to remove Role';
          setTimeout(() => {
            errorMessage.value = null;
          }, 6000);
        } else {
          renderReady.value = false;
          console.log(`selectedRole ${selectedRole.value}`);
          const data = {
            user_ohr: ohrToAssignRole.value,
            role_name: selectedRole.value,
          };
          console.log(`data ${JSON.stringify(data)}`);
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const res: any = await removeRoleFromUser(data);
          resMessage.value = res.data;
          renderReady.value = true;
          showSuccessMessage.value = true;
          console.log(`showSuccessMessage.value ${JSON.stringify(res)}`);
          setTimeout(() => {
            showSuccessMessage.value = false;
          }, 2000);
        }
      } catch (error) {
        console.log('inside catch');
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log(err.response?.data);
          renderReady.value = true;
          resMessage.value = (err.response?.data as { message: string })?.message;
          console.log(`errorMessage.value ${errorMessage.value}`);
          showErrorMessage.value = true;
          setTimeout(() => {
            showErrorMessage.value = false;
          }, 2000);
        }
      }
    };
    onBeforeMount(async () => {
      try {
        renderReady.value = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const role: any = await invokeGetUserRole('/getUserRole');
        userRole.value = role.user_roles;
        if (userRole.value.length > 0) {
          if (userRole.value.includes('System Admin')) {
            showScreen.value = true;
          } else {
            showScreen.value = false;
          }
          const roleRes = await getAllRoles();
          roles.value = roleRes.data.roles;
        }
        // userRole.value = role.user_roles;

        renderReady.value = true;
        // userRole.value = localStorage.getItem('user_roles') ? localStorage.getItem('user_roles') : [];
        // if (userRole.value.length > 0) {
        //   if (userRole.value.includes('System Admin')) {
        //     showScreen.value = true;
        //   }
        // }
      } catch (error) {
        console.log(error);
      }
      // userRole.value = localStorage.getItem('user_roles') ? localStorage.getItem('user_roles') : [];
      // if (userRole.value.length > 0) {
      //   if (userRole.value.includes('System Admin') || userRole.value.includes('System Admin View Access')) {
      //     showScreen.value = true;
      //   }
      // }
    });
    return {
      renderReady,
      roles,
      ohrToAssignRole,
      selectedRole,
      updateRecord,
      errorMessage,
      showScreen,
      resMessage,
      showErrorMessage,
      showSuccessMessage,
      removeRole,
    };
  },
});
